export default __webpack_public_path__ + "static/media/energy-icon.5f1fc868.svg";